/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $closeButton = $el.find('button');

const $header = $('[data-component="templates/header"]');

$closeButton.on('click', function () {
    TweenLite.to($el, 0.5, {
        marginTop: -$el.outerHeight(),
        onComplete: function () {
            $el.remove();
        }
    });

    TweenLite.to($header, 0.5, { marginTop: 0 });
});

const showAlert = function () {
    TweenLite.set($header, { marginTop: 0 });
    TweenLite.to($header, 0.5, { marginTop: $el.outerHeight() });

    TweenLite.set($el, { marginTop: -$el.outerHeight(), display: 'flex' });
    TweenLite.to($el, 0.5, { marginTop: 0 });
};

// Get referer url
const refererUrl = document.referrer;
const hash = window.location.hash;

const haveToShow = hash === '#asacom';

if (haveToShow) {
    setTimeout(() => showAlert(), 1300);
}
